<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import SimManagementTable from '@components/tables/sim-management-table.vue'
import ConnectionManagementTable from '@components/tables/connection-management-table.vue'
import HardwareManagementTable from '@components/tables/hardware-management-table.vue'
import ConflictsTable from '@components/tables/conflicts-table.vue'
import ConnectionsConflictsTable from '@components/tables/connections-conflicts-table.vue'
import axios from 'axios'
import { httpServices } from '@utils/http-services'
import { permissionsService } from '@utils/permissions'
import { getHardwareSerial } from '@utils/hardware'

export default {
  page: {
    title: 'SIMs Management',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    ConnectionsConflictsTable,
    Layout,
    SimManagementTable,
    ConnectionManagementTable,
    HardwareManagementTable,
    ConflictsTable,
  },
  data() {
    return {
      visibleConnectionModal: null,
      workingLinks: null,
      confirmLoadingConnectionModal: null,
      connectionsConflict: [],
      modalTextConnections: 'Fetching Connection data...',
      modalText: 'Fetching SIM data...',
      visible: false,
      confirmLoading: false,
      simsLoaded: false,
      sims: [],
      hardwaresLoaded: false,
      hardwares: null,
      simbank: null,
      conflicts: [],
      connections: null,
      groups: [],
      isVanishedAdmin: permissionsService.isVanishedAdmin(),
      showCRUD: this.$auth.user.profile.permissions.organization === 'vanished',
    }
  },
  mounted() {
    this.getSims()
    this.getGroups()
    this.getHardwares()
  },
  methods: {
    async showModal() {
      this.visible = true
      this.confirmLoading = true
      this.simbank = await httpServices.getSimBank()
      this.confirmLoading = false
      this.sims.forEach((sim) => {
        const m = this.simbank.filter((s) => s.imsi === sim.imsi)[0]
        if (m) {
          if (m && m.slot !== sim.simSlot) {
            sim.slot = m.slot
            this.conflicts.push(sim)
          }
        }
      })
      this.modalText = null
    },
    async showConnectionModal() {
      this.visibleConnectionModal = true
      this.confirmLoadingConnectionModal = true
      this.workingLinks = await httpServices.getAllWorkingLinks()
      this.confirmLoadingConnectionModal = false
      this.connections.forEach((conn) => {
        const m = this.workingLinks.filter(
          (link) =>
            link.deviceSn === getHardwareSerial(conn.hardwareId) &&
            link.deviceWan === conn.id
        )[0]

        if (m) {
          if (m && m.imsi !== conn.imsi) {
            conn.hw_imsi = m.imsi
            this.connectionsConflict.push(conn)
          }
        }
      })
      this.modalTextConnections = null
    },
    handleOk(e) {
      this.visible = false
      this.getSims()
      this.conflicts = []
      this.modalText = 'Fetching SIM data...'
    },
    handleConnectionOk(e) {
      this.visibleConnectionModal = false
      this.getConnections()
      this.connectionsConflict = []
      this.modalText = 'Fetching Connection data...'
    },
    handleConnectionCancel(e) {
      this.visibleConnectionModal = false
      this.getSims()
      this.connectionsConflict = []
      this.modalText = 'Fetching Connection data...'
    },
    handleCancel(e) {
      this.visible = false
      this.getSims()
      this.conflicts = []
      this.modalText = 'Fetching SIM data...'
    },
    createSim() {
      this.$router.push({
        name: 'create-sim',
      })
    },
    onSync() {
      this.showModal()
    },
    onSyncConnections() {
      this.showConnectionModal()
    },
    createConnection() {
      this.$router.push({
        name: 'create-connection',
      })
    },
    createHardware() {
      this.$router.push({
        name: 'create-hardware',
      })
    },
    onDeleteConnection(record) {
      const connectionId = record.pk.replace('CONNECTION#', '').toLowerCase()
      httpServices.deleteConnection(connectionId, record.orgId).then(
        (_r) => {
          this.$notification.success({
            message: `Connection Deleted`,
          })
          this.getConnections()
        },
        () => {
          this.$notification.error({
            message: `Failed to Delete`,
          })
        }
      )
    },
    onDeleteSim(record) {
      const id = record.pk.replace('SIM#', '')
      this.simsLoaded = false
      httpServices.deleteSim(id, record.orgId).then(
        (res) => {
          this.$notification.success({
            message: `SIM Deleted`,
          })
          this.getSims()
        },
        () => {
          this.$notification.error({
            message: `Failed to Delete`,
          })
        }
      )
    },
    onUpdateConflict(record) {
      const slot = JSON.parse(JSON.stringify(record.slot))
      record.meta.simSlot = slot
      axios
        .put(process.env.VUE_APP_KONSUL_API_URL + '/sims', record, {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        })
        .then(
          (_r) => {
            this.conflicts = this.conflicts.filter((i) => i.pk !== record.pk)
            this.$notification.success({
              message: `Sim slot conflict resolved`,
            })
          },
          () => {
            this.$notification.error({
              message: 'Failed to Update SIM',
            })
          }
        )
    },
    onUpdateConnectionConflict(record) {
      const s = this.sims.filter((i) => i.imsi === record.hw_imsi)[0]
      record.meta.previousSim = record.meta.sim
      record.meta.sim = s.pk
      record.meta.loading = false
      httpServices.updateConnection(record.pk, record.meta, 'admin').then(
        (_r) => {
          this.connectionsConflict = this.connectionsConflict.filter(
            (i) => i.pk !== record.pk
          )
          this.$notification.success({
            message: `Connection conflict resolved`,
          })
        },
        () => {
          this.$notification.error({
            message: 'Failed to Update Connection',
          })
        }
      )
    },
    onDeleteHardware(record) {
      const id = record.pk.replace('HARDWARE#', '')
      this.hardwaresLoaded = false
      httpServices.deleteHardware(id, record.orgId).then(
        (_r) => {
          this.$notification.success({
            message: `Hardware Deleted`,
          })
          this.getHardwares()
        },
        () => {
          this.$notification.error({
            message: `Failed to Delete`,
          })
        }
      )
    },
    getGroups() {
      httpServices.getGroups().then((groups) => {
        this.groups = groups
      })
    },
    getConnections() {
      axios
        .get(process.env.VUE_APP_KONSUL_API_URL + '/connections', {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        })
        .then((res) => {
          this.connections = res.data.Items.map((conn, i) => {
            return {
              ...conn,
              key: i,
              pk: conn.pk,
              hardwareId: conn.meta.hardwareId,
              locked: conn.meta.locked,
              loading: conn.meta.loading,
              id: parseInt(conn.meta.id, 0),
              imsi:
                this?.sims.filter((j) => j.pk === conn.meta.sim)[0]?.meta
                  ?.imsi || `n/a`,
              users: conn.meta.users,
              sim: conn?.meta?.sim?.replace('SIM#', '') || 'N/A',
              orgId: conn.meta.orgId,
            }
          })
        })
    },
    getSims() {
      httpServices.getSims().then((res) => {
        this.simsLoaded = true
        this.sims = res
        this.getConnections()
      })
    },
    getHardwares() {
      axios
        .get(process.env.VUE_APP_KONSUL_API_URL + '/hardwares', {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        })
        .then((res) => {
          this.hardwaresLoaded = true
          const hardwares = res.data.Items.map((hardware, i) => {
            return {
              ...hardware,
              key: i,
              timezone: hardware.meta.timezone,
              serial: hardware.meta.serial,
              id: hardware.meta.id.toUpperCase(),
              orgId: hardware.meta.orgId,
              status: 'offline',
            }
          })
          httpServices.getHardwareStatus().then((status) => {
            if (status) {
              hardwares.forEach((h) => {
                const x = status?.data?.data.filter((s) => s.sn === h.serial)[0]
                if (x) {
                  h.status = x.status
                } else {
                  h.status = 'offline'
                }
              })
            }
            this.hardwares = hardwares
          })
          this.getConnections()
        })
    },
  },
}
</script>

<template>
  <Layout>
    <a-modal
      title="SIM Synchronization"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :width="'80%'"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div v-if="modalText">
        {{ modalText }}
      </div>
      <div v-else style="margin-bottom: 1rem">
        <a-statistic
          title="Conflicts"
          :value="connectionsConflict.length"
          class="demo-class"
        >
          <template v-slot:suffix>
            <span> / {{ sims.length }}</span>
          </template>
        </a-statistic>
      </div>
      <div v-if="!modalText">
        <a-col>
          <ConflictsTable
            :conflicts="conflicts"
            @updateConflict="onUpdateConflict"
          />
        </a-col>
      </div>
    </a-modal>
    <a-modal
      title="Connection Synchronization"
      :visible="visibleConnectionModal"
      :confirm-loading="confirmLoadingConnectionModal"
      :width="'80%'"
      @ok="handleConnectionOk"
      @cancel="handleConnectionCancel"
    >
      <div v-if="modalTextConnections">
        {{ modalTextConnections }}
      </div>
      <div v-else style="margin-bottom: 1rem">
        <a-statistic
          title="Conflicts"
          :value="connectionsConflict.length"
          class="demo-class"
        >
          <template v-slot:suffix>
            <span> / {{ connections.length }}</span>
          </template>
        </a-statistic>
      </div>
      <div v-if="!modalTextConnections">
        <a-col>
          <ConnectionsConflictsTable
            :conflicts="connectionsConflict"
            @updateConflictConnection="onUpdateConnectionConflict"
          />
        </a-col>
      </div>
    </a-modal>
    <div id="sim--container" class="ant-row">
      <div class="header">
        <h4>
          <a-icon type="phone" style="padding-right: 8px" />
          SIMs
        </h4>
        <div>
          <a-button
            v-if="isVanishedAdmin"
            type="ghost"
            icon="sync"
            style="margin-right: 1rem"
            @click="onSync"
            >Sync
          </a-button>
          <a-button type="ghost" icon="plus-circle" @click="createSim"
            >Add New
          </a-button>
        </div>
      </div>
      <a-card style="width: 100%; margin-top: 0">
        <div v-if="!simsLoaded" class="loader--container">
          <a-icon
            type="loading"
            style="padding-left: 8px; font-size: 24px; color: #1890ff"
            spin
          />
        </div>
        <div v-else>
          <SimManagementTable
            :groups="groups"
            :sims="sims"
            :hardwares="hardwares"
            @deleteSim="onDeleteSim"
          ></SimManagementTable>
        </div>
      </a-card>
    </div>

    <div v-if="isVanishedAdmin" id="conn--container" class="ant-row">
      <div class="header">
        <h4>
          <a-icon type="api" style="padding-right: 8px" />
          Connections
        </h4>
        <div>
          <a-button
            v-if="isVanishedAdmin"
            type="ghost"
            icon="sync"
            style="margin-right: 1rem"
            @click="onSyncConnections"
            >Sync
          </a-button>
          <a-button type="ghost" icon="plus-circle" @click="createConnection"
            >Add New
          </a-button>
        </div>
      </div>
      <a-card style="width: 100%; margin-top: 0">
        <div v-if="connections === null" class="loader--container">
          <a-icon
            type="loading"
            style="padding-left: 8px; font-size: 24px; color: #1890ff"
            spin
          />
        </div>
        <div v-else>
          <ConnectionManagementTable
            :groups="groups"
            :sims="sims"
            :connections="connections"
            :hardwares="hardwares"
            @deleteConnection="onDeleteConnection"
          ></ConnectionManagementTable>
        </div>
      </a-card>
    </div>

    <div v-if="isVanishedAdmin" id="hardware--container" class="ant-row">
      <div class="header">
        <h4>
          <a-icon type="api" style="padding-right: 8px" />
          Hardware
        </h4>
        <a-button type="ghost" icon="plus-circle" @click="createHardware"
          >Add New
        </a-button>
      </div>
      <a-card style="width: 100%; margin-top: 0">
        <div v-if="!hardwares" class="loader--container">
          <a-icon
            type="loading"
            style="padding-left: 8px; font-size: 24px; color: #1890ff"
            spin
          />
        </div>
        <div v-else>
          <HardwareManagementTable
            :hardwares="hardwares"
            @deleteHardware="onDeleteHardware"
          ></HardwareManagementTable>
        </div>
      </a-card>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

#sim--container,
#conn--container,
#hardware--container {
  position: relative;
  width: 100%;
  padding: 16px;
  margin: 0 0 16px;
  background: white;
  border: 1px solid #ebedf0;
  box-shadow: 4px 8px 24px 5px rgb(208 216 243 / 60%);
  transition: all 0.2s;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    margin-bottom: 0;
    text-align: left;
    background: #141414;
    border-radius: 4px 4px 0 0;

    h4 {
      margin: 0;
      font-weight: 100;
      color: white;
    }
  }

  .ant-card {
    margin: 1.6rem auto;

    .ant-card-head-title {
      font-weight: 700;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  table tr td {
    text-transform: capitalize;
  }
}
</style>
